import { AutowireParameters } from './AnyCaptcha';

const defaultAutowireParameters: AutowireParameters = {
    challengeContainerSelector: '.any-captcha-challenge',
    solitionInputName: 'any_captcha_soltion',
    autocreateSolutionInput: true,
    formContainerSelector: 'form',
    onSolvedAction: 'submit',
}

export default defaultAutowireParameters;
